import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for change password payload
 */
export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

/**
 * Hook for changing password using TanStack React Query
 */
export const useChangePassword = (close: () => void) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: ChangePasswordPayload) => {
      const response = await apiClient.post<void>('/auth/change-password/', payload);
      return response.data;
    },
    onSuccess: () => {
      close();
      openToast({
        show: true,
        heading: 'Password updated successfully!',
        text: '',
        type: 'success',
        timeOut: 2000,
      });
    },
    onError: (err: any) => {
      console.error('Change Password Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.error?.message ||
        'Failed to change password, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};